import { render, staticRenderFns } from "./ApplicationStatusChipCpt.vue?vue&type=template&id=7472fdda&scoped=true&"
import script from "./ApplicationStatusChipCpt.vue?vue&type=script&lang=ts&"
export * from "./ApplicationStatusChipCpt.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationStatusChipCpt.vue?vue&type=style&index=0&id=7472fdda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472fdda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
